<template>
  <i class="icon-notsupport el-icon-error"></i>
</template>
<script>
export default {
  name: 'icon-notsupport',
}
</script>
<style lang="less">
.icon-notsupport {
  font-size: 20px;
  line-height: 20px;
  vertical-align: middle;
  color: #606266;
}
</style>